import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { GrupoUsuarioService } from 'src/services/grupo-usuario.service';
import { PermissoesService } from 'src/services/permissoes.service';

@Component({
    selector: 'app-grupo-usuario',
    templateUrl: './grupo-usuario.component.html',
    styleUrls: ['./grupo-usuario.component.scss'],
    standalone: false
})
export class GrupoUsuarioComponent implements OnInit, AfterViewInit {
  data: any[] = []
  form: FormGroup;
  displayModal: boolean = false
  loading: boolean = false
  @ViewChild('tableWrapper', { static: false }) tableWrapper: ElementRef;
  scrollHeight: string = '600px';
  constructor(
    protected _formBuilder: FormBuilder,
    protected _grupoUsuarioService: GrupoUsuarioService,
    protected permissaoService: PermissoesService,
  ) { }
  
  
  ngOnInit(): void {
    this.form = this._formBuilder.group({
      id: [null],
      ativo: [null],
      nome: [null],
      usuario_interno: [null],
    })
    this.index()
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.calculateScrollHeight();
    }, 200);
  }

  calculateScrollHeight(): void {
    if (this.tableWrapper && this.tableWrapper.nativeElement) {
      const wrapperHeight = this.tableWrapper.nativeElement.offsetHeight;
      const calculatedHeight = wrapperHeight - 120;
      this.scrollHeight = `${Math.max(calculatedHeight, 300)}px`;
    }
  }

  index(){
    this._grupoUsuarioService.index().subscribe(json => {
      // Normaliza o campo usuario_interno nos dados do grid
      this.data = (json || []).map(item => ({
        ...item,
        usuario_interno: item.usuario_interno !== undefined ? item.usuario_interno : (item.grupo_usuario !== undefined ? item.grupo_usuario : false)
      }));
      setTimeout(() => {
        this.calculateScrollHeight();
      }, 200);
    })
  }

  openNew(){
    this.form.reset()
    this.form.get('ativo').setValue(true)
    this.form.get('usuario_interno').setValue(false)
    this.displayModal = true
  }

  save(){
    let form = this.form.value
    this._grupoUsuarioService.save(form, form.id).subscribe(json => {
      this.loading = false
      this.index()
      this.displayModal = false
    })

  }

  edit(event){
    this.form.reset()
    this._grupoUsuarioService.show(event.id).subscribe(json => {
      // Garante que o campo usuario_interno seja mapeado corretamente
      const formData = {
        ...json,
        usuario_interno: json.usuario_interno !== undefined ? json.usuario_interno : (json.grupo_usuario !== undefined ? json.grupo_usuario : false)
      }
      this.form.patchValue(formData)
      this.displayModal = true
    })
  }

}
